import React, { useState, useRef, useEffect } from 'react'
import './index.css'

const CustomAudioPlayer = ({ audio,owner }) => {
  const [isPlaying, setIsPlaying] = useState(false)
  const [currentTime, setCurrentTime] = useState(0)
  const [duration, setDuration] = useState(0)
  const audioPlayer = useRef(null)

  useEffect(() => {
    if (audioPlayer.current) {
      audioPlayer.current.addEventListener('timeupdate', handleTimeUpdate)
      audioPlayer.current.addEventListener(
        'loadedmetadata',
        handleLoadedMetadata
      )
    }
  }, [])

  const togglePlayPause = () => {
    if (isPlaying) {
      audioPlayer.current.pause()
    } else {
      audioPlayer.current.play()
    }
    setIsPlaying(!isPlaying)
  }

  const handleTimeUpdate = () => {
    setCurrentTime(audioPlayer.current.currentTime)
  }

  const handleLoadedMetadata = () => {
    setDuration(audioPlayer.current.duration)
  }

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60)
    const seconds = Math.floor(time % 60)
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
  }

  const handleProgressChange = (e) => {
    const newTime = (e.target.value / 100) * duration
    audioPlayer.current.currentTime = newTime
    setCurrentTime(newTime)
  }

  const progressBarValue = (currentTime / duration) * 100
  console.log(progressBarValue)
  useEffect(() => {
    if (progressBarValue >= 100) {
      setIsPlaying(false)
    }
  }, [progressBarValue, setIsPlaying])
  return (
    <div className={'audioContainer'} style={{flexDirection:`${owner ? 'row-reverse' :'row'}`}}>
      <button className={'playButton'} onClick={togglePlayPause}>
        {isPlaying ? '❚❚' : '►'}
      </button>
      <input
        type='range'
        style={{ width: '10px' }}
        value={progressBarValue}
        onChange={handleProgressChange}
        className={'progressBar'}
      />
      <div className={'timeContainer'} style={{color:`${owner?'#ffffff':'#ca5cd4'}`}}>
        <p>{formatTime(currentTime)}</p> / <p>{formatTime(duration)}</p>
      </div>
      <audio
        ref={audioPlayer}
        src={audio}
        className={'hiddenAudioElement'}
      ></audio>
    </div>
  )
}

export default CustomAudioPlayer
